export default function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-24 bg-gradient-to-br from-[#03C75A] to-[#00A843]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="flex justify-center">
          {/* Info */}
          <div className="text-white max-w-2xl w-full">
            <span className="inline-block bg-white/20 text-white text-xs sm:text-sm font-bold px-3 sm:px-4 py-1.5 rounded-full mb-4 sm:mb-6">
              상담 신청
            </span>
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-black mb-3 sm:mb-4">
              지금 바로<br />무료 상담 받으세요
            </h2>
            <p className="text-white/80 text-sm sm:text-lg mb-6 sm:mb-8 leading-relaxed">
              24시간 365일 전문 상담사가 대기 중입니다.<br />
              신용카드 관련 모든 대출을 안내해 드립니다.
            </p>

            <div className="space-y-3 sm:space-y-4">
              {[
                { icon: 'ri-phone-fill', label: '휴대폰', value: '010-6606-5909', href: 'tel:01066065909' },
                { icon: 'ri-phone-line', label: '일반 전화 상담', value: '02-704-5909', href: 'tel:027045909' },
                { icon: 'ri-map-pin-2-line', label: '사무실 위치', value: '서울시 마포구 신촌로 162, 706호', href: '#' },
                { icon: 'ri-time-line', label: '영업 시간', value: '24시간 365일 운영', href: '#' },
              ].map((item) => (
                <div key={item.label} className="flex items-center gap-3 sm:gap-4">
                  <div className="w-9 h-9 sm:w-10 sm:h-10 flex items-center justify-center bg-white/20 rounded-xl shrink-0">
                    <i className={`${item.icon} text-lg sm:text-xl text-white`}></i>
                  </div>
                  <div>
                    <p className="text-white/70 text-xs">{item.label}</p>
                    {item.href !== '#' ? (
                      <a href={item.href} className="text-white font-bold text-sm sm:text-base cursor-pointer hover:underline">{item.value}</a>
                    ) : (
                      <p className="text-white font-bold text-sm sm:text-base">{item.value}</p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
